// extracted by mini-css-extract-plugin
export default {"container":"SO9njw"};